import noop from 'lodash-es/noop'
import { createContext } from 'react'

import { Asset } from '@/lib/features/Assets/interfaces'

type ReplayContextValue = {
  replayAsset: Asset | undefined
  setReplayAsset: (replay: Asset | undefined) => void
  available: boolean
  hoveredTimestamp: number | null
  setHoveredTimestamp: (ts: number | null) => void
}

export const ReplayContext = createContext<ReplayContextValue>({
  replayAsset: undefined,
  setReplayAsset: noop,
  available: false,
  hoveredTimestamp: null,
  setHoveredTimestamp: noop,
})
